<template>
  <div ref="container">
    <v-layout>
      <select id="fsYearDropDownList" style="width:82px"></select>
      <select id="quarterDropDownList" style="width:132px"></select>
      <select id="divisionDropDownList" style="width:232px"></select>
      <select id="ccyPairDropDownList" style="width:100px"></select>
      <kendo-button
        type="button"
        title="Save Selection"
        style="color:#3379b6"
        @click="saveSelection"
        ><i class="k-icon k-i-save"></i>
      </kendo-button>
      <slot v-bind:toolbar="toolbar"></slot>
    </v-layout>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'

const $ = kendo.jQuery

export default {
  name: 'SummaryToolbar',
  data() {
    return {
      toolbar,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  methods: {
    saveSelection: function() {
      const parameters = toolbar.getSelectedValues()
      if (parameters.fsYear != -1) localStorage.setItem('summayToolbarFsYear', parameters.fsYear)
      if (parameters.quarter != -1) localStorage.setItem('summayToolbarQuarter', parameters.quarter)
      if (parameters.divisions != '[]')
        localStorage.setItem('summayToolbarDivisions', parameters.divisions)

      notification('Selection saved successfully!')
    },
  },
  async mounted() {
    await toolbar.createToolbar(this)
    const parameters = toolbar.getSelectedValues()
    this.$emit('change', parameters)
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
}

const toolbar = (() => {
  'use strict'
  let fsYearDropDown, quarterDropDown, divisionDropDown, ccyPairDropDown
  let vm

  function createFsYearDropDown() {
    return new Promise(function(resolve) {
      fsYearDropDown = $('#fsYearDropDownList')
        .kendoDropDownList({
          dataTextField: 'fsYear',
          dataValueField: 'fsYear',
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/ffecReconciliationReport/getFsYears',
                cache: false,
                type: 'GET',
                dataType: 'json',
              },
            },
          },
          dataBound: function() {
            const viewValue = Number(localStorage.getItem('summayToolbarFsYear'))
            if (viewValue > 0) this.value(viewValue)
            else this.select(0)

            resolve(fsYearDropDown)
          },
          change: function() {
            quarterDropDown.dataSource.read().then(function() {
              quarterDropDown.trigger('change')
            })
          },
        })
        .data('kendoDropDownList')
    })
  }

  function createCcyPairDropDown() {
    return new Promise(function(resolve) {
      ccyPairDropDown = $('#ccyPairDropDownList')
        .kendoDropDownList({
          dataTextField: 'ccyPairCode',
          dataValueField: 'ccyPairId',
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/ffecReconciliationReport/getCcyPair',
                data: function() {
                  const {fsYear, divisions} = getSelectedValues()
                  return {
                    fsYear,
                    clientId: vm.clientId,
                    divisions,
                  }
                },
                cache: false,
                type: 'GET',
                dataType: 'json',
              },
            },
          },
          dataBound: function() {
            this.select(0)
            resolve(ccyPairDropDown)
          },
          change: function() {
            vm.$emit('change', getSelectedValues())
          },
        })
        .data('kendoDropDownList')
    })
  }

  function createQuarterDropDown() {
    return new Promise(function(resolve) {
      quarterDropDown = $('#quarterDropDownList')
        .kendoDropDownList({
          dataTextField: 'quarter',
          dataValueField: 'quarterId',
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/ffecReconciliationReport/getQuarters',
                type: 'GET',
                dataType: 'json',
                cache: false,
                data: function() {
                  return {
                    fsYear: fsYearDropDown.value(),
                  }
                },
              },
            },
          },
          dataBound: function() {
            const viewValue = Number(localStorage.getItem('summayToolbarQuarter'))
            if (viewValue > 0) this.value(viewValue)
            else this.select(0)

            resolve(quarterDropDown)
          },
          change: function() {
            vm.$emit('change', getSelectedValues())
          },
        })
        .data('kendoDropDownList')
    })
  }

  function createDivisionDateDropDown() {
    return new Promise(function(resolve) {
      divisionDropDown = $('#divisionDropDownList')
        .kendoMultiSelect({
          dataTextField: 'division',
          dataValueField: 'divisionId',
          tagMode: 'single',
          autoClose: false,
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/ffecReconciliationReport/getDivisions',
                cache: false,
                type: 'GET',
                dataType: 'json',
              },
            },
          },
          dataBound: function(e) {
            const selectedValues = e.sender.dataSource.data().map(x => x.divisionId)
            const viewValues = JSON.parse(localStorage.getItem('summayToolbarDivisions'))
            this.value(viewValues || selectedValues)
            resolve(divisionDropDown)
          },
          change: function() {
            if (this.value().length === 0) {
              const viewValues = JSON.parse(localStorage.getItem('summayToolbarDivisions'))
              this.value(viewValues)
            }
            vm.$emit('change', getSelectedValues())
          },
        })
        .data('kendoMultiSelect')
    })
  }

  function createToolbar() {
    return new Promise(function(toolbarResolve) {
      createFsYearDropDown().then(function() {
        createDivisionDateDropDown().then(function() {
          createQuarterDropDown().then(function() {
            createCcyPairDropDown().then(function() {
              toolbarResolve()
            })
          })
        })
      })
    })
  }

  function getSelectedValues() {
    return {
      clientId: Number(vm.clientId),
      fsYear: Number(fsYearDropDown.value() || -1),
      quarter: Number(quarterDropDown.value() || -1),
      divisions: JSON.stringify(divisionDropDown.value()),
      divisionsList: divisionDropDown.value(),
      ccyPairId: ccyPairDropDown ? Number(ccyPairDropDown.value() || -1) : -1,
    }
  }

  return {
    createToolbar($vm) {
      vm = $vm
      return createToolbar()
    },
    getSelectedValues: getSelectedValues,
  }
})()
</script>
